import { ReactChild, useState, createContext, useContext } from 'react';

export const FilterAndSearchContext = createContext({
  filter: [] as string[],
  search: '',
  setFilter: (v: string[]): void => {},
  setSearch: (v: string): void => {}
});

export const FilterAndSearchContextProvider = (props: { children: ReactChild | ReactChild[] }) => {
  const [filter, setFilter]: [string[], (v: string[]) => void] = useState([] as string[]);
  const [search, setSearch]: [string, (v: string) => void] = useState('');

  return (
    <FilterAndSearchContext.Provider value={{ filter, search, setFilter, setSearch }}>
      <>{props.children}</>
    </FilterAndSearchContext.Provider>
  );
};

export const useFilterAndSearchContext = () => useContext(FilterAndSearchContext);
